import { css } from '@emotion/css'
import { colors, mediaQueryHelper, breakpoint, shorthandHelper, spacing } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    display: 'flex',

    '& li': {
      display: 'inline-flex',
      alignItems: 'center',
      color: colors.oxfordBlue,
    },

    '& a': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: 120,

      [mediaQueryHelper(420)]: {
        maxWidth: 150,
      },

      [mediaQueryHelper(breakpoint.phone)]: {
        maxWidth: 250,
      },

      [mediaQueryHelper(breakpoint.tablet)]: {
        maxWidth: 'none',
        overflow: 'visible',
        whiteSpace: 'normal',
        textOverflow: 'unset',
      },
    },
  }),

  icon: css({
    margin: shorthandHelper([0, spacing.small]),
  }),
}

export default styles
